/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Aiflowprice2Inputs */

const en_aiflowprice2 = /** @type {(inputs: Aiflowprice2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits`)
};

const de_aiflowprice2 = /** @type {(inputs: Aiflowprice2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} Credits`)
};

/**
* | output |
* | --- |
* | "{credits} credits" |
*
* @param {Aiflowprice2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowprice2 = /** @type {((inputs: Aiflowprice2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowprice2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowprice2(inputs)
	return de_aiflowprice2(inputs)
});
export { aiflowprice2 as "aiFlowPrice" }